module.exports = __webpack_public_path__ + "res/ic_arrow_a_z_m.3a9a64824a08993ef5f8b46267387767.png";